// extracted by mini-css-extract-plugin
export default {"allProjects":"WebDevAllProjects_allProjects__mQEbB","dataProjLinkParent":"WebDevAllProjects_dataProjLinkParent__d6p4j","dataProjLink":"WebDevAllProjects_dataProjLink__z8ZaY"};